import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/restaurant/dish-details1.jpg'
import _imports_1 from '@/assets/images/restaurant/dish-details2.jpg'
import _imports_2 from '@/assets/images/restaurant/dish-details3.jpg'
import _imports_3 from '@/assets/images/restaurant/dish-details4.jpg'


const _hoisted_1 = { class: "row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "col-lg-4" }, [
      _createElementVNode("div", {
        class: "tab-content mb-3 card border-0 bg-white p-3 rounded-2",
        id: "myTabContent"
      }, [
        _createElementVNode("div", {
          class: "tab-pane fade show active",
          id: "nft-details1-tab-pane",
          role: "tabpanel",
          "aria-labelledby": "nft-details1-tab",
          tabindex: "0"
        }, [
          _createElementVNode("img", {
            src: _imports_0,
            class: "rounded-2",
            alt: "nft-details"
          })
        ]),
        _createElementVNode("div", {
          class: "tab-pane fade",
          id: "nft-details2-tab-pane",
          role: "tabpanel",
          "aria-labelledby": "nft-details2-tab",
          tabindex: "0"
        }, [
          _createElementVNode("img", {
            src: _imports_1,
            class: "rounded-2",
            alt: "nft-details"
          })
        ]),
        _createElementVNode("div", {
          class: "tab-pane fade",
          id: "nft-details3-tab-pane",
          role: "tabpanel",
          "aria-labelledby": "nft-details3-tab",
          tabindex: "0"
        }, [
          _createElementVNode("img", {
            src: _imports_2,
            class: "rounded-2",
            alt: "nft-details"
          })
        ]),
        _createElementVNode("div", {
          class: "tab-pane fade",
          id: "nft-details4-tab-pane",
          role: "tabpanel",
          "aria-labelledby": "nft-details4-tab",
          tabindex: "0"
        }, [
          _createElementVNode("img", {
            src: _imports_3,
            class: "rounded-2",
            alt: "nft-details"
          })
        ])
      ]),
      _createElementVNode("ul", {
        class: "nav nav-tabs gap-3 nft-detail-tabs border-0 justify-content-center",
        id: "myTab",
        role: "tablist"
      }, [
        _createElementVNode("li", {
          class: "nav-item",
          role: "presentation"
        }, [
          _createElementVNode("button", {
            class: "nav-link p-0 border-0 active",
            id: "nft-details1-tab",
            "data-bs-toggle": "tab",
            "data-bs-target": "#nft-details1-tab-pane",
            type: "button",
            role: "tab",
            "aria-controls": "nft-details1-tab-pane",
            "aria-selected": "true"
          }, [
            _createElementVNode("img", {
              src: _imports_0,
              class: "rounded-2",
              style: {"width":"110px"},
              alt: "nft-details"
            })
          ])
        ]),
        _createElementVNode("li", {
          class: "nav-item",
          role: "presentation"
        }, [
          _createElementVNode("button", {
            class: "nav-link p-0 border-0",
            id: "nft-details2-tab",
            "data-bs-toggle": "tab",
            "data-bs-target": "#nft-details2-tab-pane",
            type: "button",
            role: "tab",
            "aria-controls": "nft-details2-tab-pane",
            "aria-selected": "false"
          }, [
            _createElementVNode("img", {
              src: _imports_1,
              class: "rounded-2",
              style: {"width":"110px"},
              alt: "nft-details"
            })
          ])
        ]),
        _createElementVNode("li", {
          class: "nav-item",
          role: "presentation"
        }, [
          _createElementVNode("button", {
            class: "nav-link p-0 border-0",
            id: "nft-details3-tab",
            "data-bs-toggle": "tab",
            "data-bs-target": "#nft-details3-tab-pane",
            type: "button",
            role: "tab",
            "aria-controls": "nft-details3-tab-pane",
            "aria-selected": "false"
          }, [
            _createElementVNode("img", {
              src: _imports_2,
              class: "rounded-2",
              style: {"width":"110px"},
              alt: "nft-details"
            })
          ])
        ]),
        _createElementVNode("li", {
          class: "nav-item",
          role: "presentation"
        }, [
          _createElementVNode("button", {
            class: "nav-link p-0 border-0",
            id: "nft-details4-tab",
            "data-bs-toggle": "tab",
            "data-bs-target": "#nft-details4-tab-pane",
            type: "button",
            role: "tab",
            "aria-controls": "nft-details4-tab-pane",
            "aria-selected": "false"
          }, [
            _createElementVNode("img", {
              src: _imports_3,
              class: "rounded-2",
              style: {"width":"110px"},
              alt: "nft-details"
            })
          ])
        ])
      ])
    ], -1),
    _createStaticVNode("<div class=\"col-lg-8\" data-v-12c32f86><div class=\"dish-details-card trezo-card card border-radius d-block bg-white border-0 shadow-none\" data-v-12c32f86><div class=\"trezo-card-content\" data-v-12c32f86><div class=\"d-md-flex align-items-center justify-content-between\" data-v-12c32f86><div data-v-12c32f86><span class=\"d-block text-xs\" data-v-12c32f86> Code: 3479 </span><h3 data-v-12c32f86>Beef Cheesy Burger</h3><span class=\"price fw-semibold\" data-v-12c32f86> $11.50 USD </span></div><div class=\"ratings lh-1\" data-v-12c32f86><i class=\"ri-star-fill\" data-v-12c32f86></i><i class=\"ri-star-fill\" data-v-12c32f86></i><i class=\"ri-star-fill\" data-v-12c32f86></i><i class=\"ri-star-fill\" data-v-12c32f86></i><i class=\"ri-star-fill\" data-v-12c32f86></i><span class=\"d-inline-block lh-1 text-xs text-body\" data-v-12c32f86> 5.0 </span></div></div><div class=\"border-top\" data-v-12c32f86></div><h4 class=\"fw-semibold\" data-v-12c32f86>Ingredients Details</h4><p data-v-12c32f86> Spaghetti, shredded chicken, buffalo sauce, ranch dressing, mozzarella. </p><div class=\"mb-25\" data-v-12c32f86></div><h4 class=\"fw-semibold\" data-v-12c32f86>Nutrition Values</h4><div class=\"nutrition-values\" data-v-12c32f86><div class=\"row g-0\" data-v-12c32f86><div class=\"col-md-6\" data-v-12c32f86><div class=\"item d-flex align-items-center justify-content-between\" data-v-12c32f86><span class=\"d-block\" data-v-12c32f86> Calories </span><span class=\"d-block\" data-v-12c32f86><span class=\"text-black\" data-v-12c32f86>1200</span> Kcal </span></div></div><div class=\"col-md-6\" data-v-12c32f86><div class=\"item d-flex align-items-center justify-content-between\" data-v-12c32f86><span class=\"d-block\" data-v-12c32f86> Carbs </span><span class=\"d-block\" data-v-12c32f86><span class=\"text-black\" data-v-12c32f86>120</span> gm </span></div></div><div class=\"col-md-6\" data-v-12c32f86><div class=\"item d-flex align-items-center justify-content-between\" data-v-12c32f86><span class=\"d-block\" data-v-12c32f86> Protein </span><span class=\"d-block\" data-v-12c32f86><span class=\"text-black\" data-v-12c32f86>120</span> gm </span></div></div><div class=\"col-md-6\" data-v-12c32f86><div class=\"item d-flex align-items-center justify-content-between\" data-v-12c32f86><span class=\"d-block\" data-v-12c32f86> Fibres </span><span class=\"d-block\" data-v-12c32f86><span class=\"text-black\" data-v-12c32f86>400</span> gm </span></div></div><div class=\"col-md-6\" data-v-12c32f86><div class=\"item d-flex align-items-center justify-content-between\" data-v-12c32f86><span class=\"d-block\" data-v-12c32f86> Fat </span><span class=\"d-block\" data-v-12c32f86><span class=\"text-black\" data-v-12c32f86>890</span> gm </span></div></div><div class=\"col-md-6\" data-v-12c32f86><div class=\"item d-flex align-items-center justify-content-between\" data-v-12c32f86><span class=\"d-block\" data-v-12c32f86> Vitamins </span><span class=\"d-block\" data-v-12c32f86><span class=\"text-black\" data-v-12c32f86>350</span> gm </span></div></div><div class=\"col-md-6\" data-v-12c32f86><div class=\"item d-flex align-items-center justify-content-between\" data-v-12c32f86><span class=\"d-block\" data-v-12c32f86> Sugar </span><span class=\"d-block\" data-v-12c32f86><span class=\"text-black\" data-v-12c32f86>30</span> gm </span></div></div><div class=\"col-md-6\" data-v-12c32f86><div class=\"item d-flex align-items-center justify-content-between\" data-v-12c32f86><span class=\"d-block\" data-v-12c32f86> Minerals </span><span class=\"d-block\" data-v-12c32f86><span class=\"text-black\" data-v-12c32f86>5</span> gm </span></div></div></div></div><h4 class=\"fw-semibold mb-0 d-flex align-items-center justify-content-between\" data-v-12c32f86> Orders In Queue <span data-v-12c32f86>17</span></h4></div></div></div>", 1)
  ]))]))
}